import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { styles } from './styles';

export const AppFooter = () => {
  const { t } = useTranslation();

  return (
    <Box component="footer" sx={styles.root}>
      <Typography component="p" sx={styles.text}>
        {t('footer.copyright')}
      </Typography>
    </Box>
  );
};
